import { useTheme } from "../../styles/theme";
import { useApp } from "../../context/AppContext";
import { dispDate } from "../../utils/dates";
import { fmt } from "../../utils/format";
import SectionTitle from "../../components/SectionTitle";

export default function Ledger() {
  const S = useTheme();
  const c = S.colors;
  const { filterDate, setFilterDate, ledgerEntries } = useApp();

  const TYPE_COLORS = {
    "Opening Balance": { bg: c.infoBg, color: c.info },
    Income: { bg: c.incomeBg, color: c.primary },
    "Vendor Credit": { bg: c.vendorCreditBg, color: c.warn },
    Expense: { bg: c.expenseBg, color: c.purple },
    Salary: { bg: c.salaryBg, color: c.indigo },
    "Debt Payment": { bg: c.debtPaymentBg, color: c.info },
  };

  const netFlow = ledgerEntries.reduce((a, b) => a + b.sign * b.amount, 0);

  return (
    <div>
      <SectionTitle>Full Transaction Ledger</SectionTitle>

      {/* Filter bar */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 16 }}>
        <label style={{ color: c.textMuted, fontSize: 13 }}>Filter by date:</label>
        <input style={{ ...S.input, width: 180 }} type="date"
          value={filterDate}
          onChange={e => setFilterDate(e.target.value)} />
        {filterDate && (
          <button style={S.clearBtn} onClick={() => setFilterDate("")}>Clear</button>
        )}
      </div>

      {/* Legend */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 16 }}>
        {Object.entries(TYPE_COLORS).map(([t, tc]) => (
          <span key={t} style={{ ...S.typeBadge, background: tc.bg, color: tc.color }}>{t}</span>
        ))}
      </div>

      {/* Table */}
      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              {["Date","Type","Description","Detail","Amount","Flow"].map(h => (
                <th key={h} style={S.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ledgerEntries.length === 0 && (
              <tr><td colSpan={6} style={S.emptyCell}>No entries found.</td></tr>
            )}
            {ledgerEntries.map((e, i) => {
              const tc = TYPE_COLORS[e.type] || { bg: c.surfaceAlt, color: c.textMuted };
              return (
                <tr key={i} style={S.tr}>
                  <td style={S.td}>{dispDate(e.date)}</td>
                  <td style={S.td}>
                    <span style={{ ...S.typeBadge, background: tc.bg, color: tc.color }}>{e.type}</span>
                  </td>
                  <td style={S.td}>{e.label}</td>
                  <td style={{ ...S.td, color: c.textDim, fontSize: 12 }}>{e.detail || "—"}</td>
                  <td style={{ ...S.td, fontWeight: 700 }}>{fmt(e.amount)}</td>
                  <td style={{ ...S.td, fontWeight: 700, color: e.sign > 0 ? c.primary : c.dangerLight }}>
                    {e.sign > 0 ? "▲ IN" : "▼ OUT"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* Footer totals */}
      <div style={S.ledgerFooter}>
        <div style={S.ledgerTotal}>
          <span style={{ color: c.textDim }}>Entries:</span>
          <span style={{ fontWeight: 700 }}>{ledgerEntries.length}</span>
        </div>
        <div style={S.ledgerTotal}>
          <span style={{ color: c.textDim }}>Net:</span>
          <span style={{ fontWeight: 700, color: netFlow >= 0 ? c.primary : c.danger }}>
            {fmt(netFlow)}
          </span>
        </div>
      </div>
    </div>
  );
}
